module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-standside-1700.abccf55f.svg";